const map = {
	"./allChapters/_10_melachim_a-01.txt": 87346,
	"./allChapters/_10_melachim_a-02.txt": 45373,
	"./allChapters/_10_melachim_a-03.txt": 84208,
	"./allChapters/_10_melachim_a-04.txt": 72235,
	"./allChapters/_10_melachim_a-05.txt": 63998,
	"./allChapters/_10_melachim_a-06.txt": 20425,
	"./allChapters/_10_melachim_a-07.txt": 97644,
	"./allChapters/_10_melachim_a-08.txt": 68391,
	"./allChapters/_10_melachim_a-09.txt": 55450,
	"./allChapters/_10_melachim_a-10.txt": 25620,
	"./allChapters/_10_melachim_a-11.txt": 45233,
	"./allChapters/_10_melachim_a-12.txt": 15270,
	"./allChapters/_10_melachim_a-13.txt": 23091,
	"./allChapters/_10_melachim_a-14.txt": 29048,
	"./allChapters/_10_melachim_a-15.txt": 49093,
	"./allChapters/_10_melachim_a-16.txt": 90106,
	"./allChapters/_10_melachim_a-17.txt": 40679,
	"./allChapters/_10_melachim_a-18.txt": 44812,
	"./allChapters/_10_melachim_a-19.txt": 74313,
	"./allChapters/_10_melachim_a-20.txt": 24885,
	"./allChapters/_10_melachim_a-21.txt": 10728,
	"./allChapters/_10_melachim_a-22.txt": 46071,
	"./allChapters/_11_melachim_b-01.txt": 54394,
	"./allChapters/_11_melachim_b-02.txt": 36677,
	"./allChapters/_11_melachim_b-03.txt": 73496,
	"./allChapters/_11_melachim_b-04.txt": 51187,
	"./allChapters/_11_melachim_b-05.txt": 43366,
	"./allChapters/_11_melachim_b-06.txt": 20913,
	"./allChapters/_11_melachim_b-07.txt": 95796,
	"./allChapters/_11_melachim_b-08.txt": 63647,
	"./allChapters/_11_melachim_b-09.txt": 86290,
	"./allChapters/_11_melachim_b-10.txt": 29852,
	"./allChapters/_11_melachim_b-11.txt": 1465,
	"./allChapters/_11_melachim_b-12.txt": 63886,
	"./allChapters/_11_melachim_b-13.txt": 23675,
	"./allChapters/_11_melachim_b-14.txt": 30624,
	"./allChapters/_11_melachim_b-15.txt": 49677,
	"./allChapters/_11_melachim_b-16.txt": 87234,
	"./allChapters/_11_melachim_b-17.txt": 39439,
	"./allChapters/_11_melachim_b-18.txt": 78807,
	"./allChapters/_11_melachim_b-19.txt": 45121,
	"./allChapters/_11_melachim_b-20.txt": 73469,
	"./allChapters/_11_melachim_b-21.txt": 54832,
	"./allChapters/_11_melachim_b-22.txt": 5183,
	"./allChapters/_11_melachim_b-23.txt": 92594,
	"./allChapters/_11_melachim_b-24.txt": 25673,
	"./allChapters/_11_melachim_b-25.txt": 96172,
	"./allChapters/_12_yeshaaya-01.txt": 19037,
	"./allChapters/_12_yeshaaya-02.txt": 14482,
	"./allChapters/_12_yeshaaya-03.txt": 895,
	"./allChapters/_12_yeshaaya-04.txt": 82860,
	"./allChapters/_12_yeshaaya-05.txt": 12361,
	"./allChapters/_12_yeshaaya-06.txt": 91134,
	"./allChapters/_12_yeshaaya-07.txt": 27659,
	"./allChapters/_12_yeshaaya-08.txt": 6744,
	"./allChapters/_12_yeshaaya-09.txt": 22341,
	"./allChapters/_12_yeshaaya-10.txt": 45563,
	"./allChapters/_12_yeshaaya-11.txt": 66926,
	"./allChapters/_12_yeshaaya-12.txt": 53977,
	"./allChapters/_12_yeshaaya-13.txt": 51740,
	"./allChapters/_12_yeshaaya-14.txt": 49423,
	"./allChapters/_12_yeshaaya-15.txt": 90274,
	"./allChapters/_12_yeshaaya-16.txt": 71565,
	"./allChapters/_12_yeshaaya-17.txt": 29216,
	"./allChapters/_12_yeshaaya-18.txt": 72547,
	"./allChapters/_12_yeshaaya-19.txt": 41014,
	"./allChapters/_12_yeshaaya-20.txt": 67862,
	"./allChapters/_12_yeshaaya-21.txt": 26243,
	"./allChapters/_12_yeshaaya-22.txt": 84100,
	"./allChapters/_12_yeshaaya-23.txt": 44385,
	"./allChapters/_12_yeshaaya-24.txt": 18986,
	"./allChapters/_12_yeshaaya-25.txt": 16567,
	"./allChapters/_12_yeshaaya-26.txt": 62824,
	"./allChapters/_12_yeshaaya-27.txt": 1269,
	"./allChapters/_12_yeshaaya-28.txt": 46798,
	"./allChapters/_12_yeshaaya-29.txt": 6587,
	"./allChapters/_12_yeshaaya-30.txt": 20177,
	"./allChapters/_12_yeshaaya-31.txt": 78708,
	"./allChapters/_12_yeshaaya-32.txt": 50451,
	"./allChapters/_12_yeshaaya-33.txt": 26278,
	"./allChapters/_12_yeshaaya-34.txt": 19589,
	"./allChapters/_12_yeshaaya-35.txt": 56408,
	"./allChapters/_12_yeshaaya-36.txt": 50247,
	"./allChapters/_12_yeshaaya-37.txt": 37306,
	"./allChapters/_12_yeshaaya-38.txt": 2281,
	"./allChapters/_12_yeshaaya-39.txt": 79500,
	"./allChapters/_12_yeshaaya-40.txt": 91388,
	"./allChapters/_12_yeshaaya-41.txt": 39705,
	"./allChapters/_12_yeshaaya-42.txt": 27534,
	"./allChapters/_12_yeshaaya-43.txt": 36187,
	"./allChapters/_12_yeshaaya-44.txt": 19840,
	"./allChapters/_12_yeshaaya-45.txt": 32173,
	"./allChapters/_12_yeshaaya-46.txt": 50882,
	"./allChapters/_12_yeshaaya-47.txt": 86127,
	"./allChapters/_12_yeshaaya-48.txt": 7364,
	"./allChapters/_12_yeshaaya-49.txt": 12769,
	"./allChapters/_12_yeshaaya-50.txt": 74951,
	"./allChapters/_12_yeshaaya-51.txt": 24378,
	"./allChapters/_12_yeshaaya-52.txt": 83365,
	"./allChapters/_12_yeshaaya-53.txt": 79672,
	"./allChapters/_12_yeshaaya-54.txt": 57363,
	"./allChapters/_12_yeshaaya-55.txt": 49542,
	"./allChapters/_12_yeshaaya-56.txt": 79505,
	"./allChapters/_12_yeshaaya-57.txt": 59892,
	"./allChapters/_12_yeshaaya-58.txt": 4447,
	"./allChapters/_12_yeshaaya-59.txt": 75506,
	"./allChapters/_12_yeshaaya-60.txt": 99938,
	"./allChapters/_12_yeshaaya-61.txt": 59087,
	"./allChapters/_12_yeshaaya-62.txt": 38880,
	"./allChapters/_12_yeshaaya-63.txt": 81229,
	"./allChapters/_12_yeshaaya-64.txt": 76590,
	"./allChapters/_12_yeshaaya-65.txt": 55227,
	"./allChapters/_12_yeshaaya-66.txt": 61404,
	"./allChapters/_13_yirmeyah-01.txt": 33085,
	"./allChapters/_13_yirmeyah-02.txt": 93906,
	"./allChapters/_13_yirmeyah-03.txt": 1887,
	"./allChapters/_13_yirmeyah-04.txt": 61676,
	"./allChapters/_13_yirmeyah-05.txt": 34313,
	"./allChapters/_13_yirmeyah-06.txt": 70558,
	"./allChapters/_13_yirmeyah-07.txt": 55499,
	"./allChapters/_13_yirmeyah-08.txt": 88440,
	"./allChapters/_13_yirmeyah-09.txt": 78469,
	"./allChapters/_13_yirmeyah-10.txt": 12251,
	"./allChapters/_13_yirmeyah-11.txt": 3598,
	"./allChapters/_13_yirmeyah-12.txt": 32121,
	"./allChapters/_13_yirmeyah-13.txt": 83804,
	"./allChapters/_13_yirmeyah-14.txt": 62191,
	"./allChapters/_13_yirmeyah-15.txt": 26946,
	"./allChapters/_13_yirmeyah-16.txt": 24589,
	"./allChapters/_13_yirmeyah-17.txt": 95904,
	"./allChapters/_13_yirmeyah-18.txt": 57635,
	"./allChapters/_13_yirmeyah-19.txt": 77078,
	"./allChapters/_13_yirmeyah-20.txt": 3926,
	"./allChapters/_13_yirmeyah-21.txt": 35011,
	"./allChapters/_13_yirmeyah-22.txt": 13828,
	"./allChapters/_13_yirmeyah-23.txt": 15681,
	"./allChapters/_13_yirmeyah-24.txt": 55050,
	"./allChapters/_13_yirmeyah-25.txt": 59959,
	"./allChapters/_13_yirmeyah-26.txt": 40968,
	"./allChapters/_13_yirmeyah-27.txt": 8149,
	"./allChapters/_13_yirmeyah-28.txt": 99822,
	"./allChapters/_13_yirmeyah-29.txt": 42651,
	"./allChapters/_13_yirmeyah-30.txt": 56241,
	"./allChapters/_13_yirmeyah-31.txt": 13332,
	"./allChapters/_13_yirmeyah-32.txt": 29651,
	"./allChapters/_13_yirmeyah-33.txt": 98534,
	"./allChapters/_13_yirmeyah-34.txt": 55653,
	"./allChapters/_13_yirmeyah-35.txt": 40056,
	"./allChapters/_13_yirmeyah-36.txt": 77863,
	"./allChapters/_13_yirmeyah-37.txt": 73370,
	"./allChapters/_13_yirmeyah-38.txt": 45673,
	"./allChapters/_13_yirmeyah-39.txt": 16172,
	"./allChapters/_13_yirmeyah-40.txt": 98492,
	"./allChapters/_13_yirmeyah-41.txt": 70105,
	"./allChapters/_13_yirmeyah-42.txt": 48878,
	"./allChapters/_13_yirmeyah-43.txt": 8667,
	"./allChapters/_13_yirmeyah-44.txt": 99264,
	"./allChapters/_13_yirmeyah-45.txt": 18317,
	"./allChapters/_13_yirmeyah-46.txt": 72226,
	"./allChapters/_13_yirmeyah-47.txt": 8079,
	"./allChapters/_13_yirmeyah-48.txt": 47447,
	"./allChapters/_13_yirmeyah-49.txt": 30113,
	"./allChapters/_13_yirmeyah-50.txt": 35975,
	"./allChapters/_13_yirmeyah-51.txt": 23034,
	"./allChapters/_13_yirmeyah-52.txt": 5317,
	"./allChapters/_14_yechezkel-01.txt": 11056,
	"./allChapters/_14_yechezkel-02.txt": 75199,
	"./allChapters/_14_yechezkel-03.txt": 97842,
	"./allChapters/_14_yechezkel-04.txt": 30921,
	"./allChapters/_14_yechezkel-05.txt": 8140,
	"./allChapters/_14_yechezkel-06.txt": 82731,
	"./allChapters/_14_yechezkel-07.txt": 74494,
	"./allChapters/_14_yechezkel-08.txt": 48229,
	"./allChapters/_14_yechezkel-09.txt": 85048,
	"./allChapters/_14_yechezkel-10.txt": 98786,
	"./allChapters/_14_yechezkel-11.txt": 50991,
	"./allChapters/_14_yechezkel-12.txt": 42176,
	"./allChapters/_14_yechezkel-13.txt": 61229,
	"./allChapters/_14_yechezkel-14.txt": 75438,
	"./allChapters/_14_yechezkel-15.txt": 35227,
	"./allChapters/_14_yechezkel-16.txt": 41404,
	"./allChapters/_14_yechezkel-17.txt": 13017,
	"./allChapters/_14_yechezkel-18.txt": 47626,
	"./allChapters/_14_yechezkel-19.txt": 45207,
	"./allChapters/_14_yechezkel-20.txt": 20775,
	"./allChapters/_14_yechezkel-21.txt": 16282,
	"./allChapters/_14_yechezkel-22.txt": 98565,
	"./allChapters/_14_yechezkel-23.txt": 82968,
	"./allChapters/_14_yechezkel-24.txt": 72563,
	"./allChapters/_14_yechezkel-25.txt": 25094,
	"./allChapters/_14_yechezkel-26.txt": 82801,
	"./allChapters/_14_yechezkel-27.txt": 39892,
	"./allChapters/_14_yechezkel-28.txt": 60767,
	"./allChapters/_14_yechezkel-29.txt": 90706,
	"./allChapters/_14_yechezkel-30.txt": 83292,
	"./allChapters/_14_yechezkel-31.txt": 54905,
	"./allChapters/_14_yechezkel-32.txt": 42734,
	"./allChapters/_14_yechezkel-33.txt": 85563,
	"./allChapters/_14_yechezkel-34.txt": 92512,
	"./allChapters/_14_yechezkel-35.txt": 54701,
	"./allChapters/_14_yechezkel-36.txt": 73410,
	"./allChapters/_14_yechezkel-37.txt": 84975,
	"./allChapters/_14_yechezkel-38.txt": 56740,
	"./allChapters/_14_yechezkel-39.txt": 58593,
	"./allChapters/_14_yechezkel-40.txt": 19025,
	"./allChapters/_14_yechezkel-41.txt": 24532,
	"./allChapters/_14_yechezkel-42.txt": 72979,
	"./allChapters/_14_yechezkel-43.txt": 18182,
	"./allChapters/_14_yechezkel-44.txt": 68965,
	"./allChapters/_14_yechezkel-45.txt": 78936,
	"./allChapters/_14_yechezkel-46.txt": 65447,
	"./allChapters/_14_yechezkel-47.txt": 40602,
	"./allChapters/_14_yechezkel-48.txt": 24809,
	"./allChapters/_15_hoshea-01.txt": 97851,
	"./allChapters/_15_hoshea-02.txt": 95580,
	"./allChapters/_15_hoshea-03.txt": 67193,
	"./allChapters/_15_hoshea-04.txt": 85698,
	"./allChapters/_15_hoshea-05.txt": 13615,
	"./allChapters/_15_hoshea-06.txt": 4800,
	"./allChapters/_15_hoshea-07.txt": 83341,
	"./allChapters/_15_hoshea-08.txt": 59126,
	"./allChapters/_15_hoshea-09.txt": 90211,
	"./allChapters/_15_hoshea-10.txt": 873,
	"./allChapters/_15_hoshea-11.txt": 71372,
	"./allChapters/_15_hoshea-12.txt": 16171,
	"./allChapters/_15_hoshea-13.txt": 79646,
	"./allChapters/_15_hoshea-14.txt": 7549,
	"./allChapters/_16_yoel-01.txt": 33441,
	"./allChapters/_16_yoel-02.txt": 56918,
	"./allChapters/_16_yoel-03.txt": 15299,
	"./allChapters/_16_yoel-04.txt": 68232,
	"./allChapters/_17_amos-01.txt": 6769,
	"./allChapters/_17_amos-02.txt": 49062,
	"./allChapters/_17_amos-03.txt": 80179,
	"./allChapters/_17_amos-04.txt": 90584,
	"./allChapters/_17_amos-05.txt": 6181,
	"./allChapters/_17_amos-06.txt": 23898,
	"./allChapters/_17_amos-07.txt": 28391,
	"./allChapters/_17_amos-08.txt": 66700,
	"./allChapters/_17_amos-09.txt": 96201,
	"./allChapters/_18_ovadia-01.txt": 12508,
	"./allChapters/_19_yona-01.txt": 654,
	"./allChapters/_19_yona-02.txt": 29177,
	"./allChapters/_19_yona-03.txt": 80860,
	"./allChapters/_19_yona-04.txt": 59247,
	"./allChapters/_1_bereshit-01.txt": 26802,
	"./allChapters/_1_bereshit-02.txt": 31357,
	"./allChapters/_1_bereshit-03.txt": 835,
	"./allChapters/_1_bereshit-04.txt": 39979,
	"./allChapters/_1_bereshit-05.txt": 3454,
	"./allChapters/_1_bereshit-06.txt": 24681,
	"./allChapters/_1_bereshit-07.txt": 95180,
	"./allChapters/_1_bereshit-08.txt": 56871,
	"./allChapters/_1_bereshit-09.txt": 52378,
	"./allChapters/_1_bereshit-10.txt": 91028,
	"./allChapters/_1_bereshit-11.txt": 32497,
	"./allChapters/_1_bereshit-12.txt": 38598,
	"./allChapters/_1_bereshit-13.txt": 62771,
	"./allChapters/_1_bereshit-14.txt": 68728,
	"./allChapters/_1_bereshit-15.txt": 31909,
	"./allChapters/_1_bereshit-16.txt": 49626,
	"./allChapters/_1_bereshit-17.txt": 62567,
	"./allChapters/_1_bereshit-18.txt": 91820,
	"./allChapters/_1_bereshit-19.txt": 14601,
	"./allChapters/_1_bereshit-20.txt": 13589,
	"./allChapters/_1_bereshit-21.txt": 75144,
	"./allChapters/_1_bereshit-22.txt": 28887,
	"./allChapters/_1_bereshit-23.txt": 31306,
	"./allChapters/_1_bereshit-24.txt": 56705,
	"./allChapters/_1_bereshit-25.txt": 96420,
	"./allChapters/_1_bereshit-26.txt": 38563,
	"./allChapters/_1_bereshit-27.txt": 80182,
	"./allChapters/_1_bereshit-28.txt": 44909,
	"./allChapters/_1_bereshit-29.txt": 25856,
	"./allChapters/_1_bereshit-30.txt": 36698,
	"./allChapters/_1_bereshit-31.txt": 87271,
	"./allChapters/_1_bereshit-32.txt": 91992,
	"./allChapters/_1_bereshit-33.txt": 95685,
	"./allChapters/_1_bereshit-34.txt": 61862,
	"./allChapters/_1_bereshit-35.txt": 92064,
	"./allChapters/_1_bereshit-36.txt": 72212,
	"./allChapters/_1_bereshit-37.txt": 91825,
	"./allChapters/_1_bereshit-38.txt": 87826,
	"./allChapters/_1_bereshit-39.txt": 16767,
	"./allChapters/_1_bereshit-40.txt": 60019,
	"./allChapters/_1_bereshit-41.txt": 52198,
	"./allChapters/_1_bereshit-42.txt": 82161,
	"./allChapters/_1_bereshit-43.txt": 62548,
	"./allChapters/_1_bereshit-44.txt": 77607,
	"./allChapters/_1_bereshit-45.txt": 27034,
	"./allChapters/_1_bereshit-46.txt": 86021,
	"./allChapters/_1_bereshit-47.txt": 82328,
	"./allChapters/_1_bereshit-48.txt": 14635,
	"./allChapters/_1_bereshit-49.txt": 47486,
	"./allChapters/_1_bereshit-50.txt": 64008,
	"./allChapters/_20_micha-01.txt": 26597,
	"./allChapters/_20_micha-02.txt": 98234,
	"./allChapters/_20_micha-03.txt": 23079,
	"./allChapters/_20_micha-04.txt": 82164,
	"./allChapters/_20_micha-05.txt": 76657,
	"./allChapters/_20_micha-06.txt": 75814,
	"./allChapters/_20_micha-07.txt": 30611,
	"./allChapters/_21_nachum-01.txt": 64070,
	"./allChapters/_21_nachum-02.txt": 10385,
	"./allChapters/_21_nachum-03.txt": 90772,
	"./allChapters/_22_havakuk-01.txt": 15831,
	"./allChapters/_22_havakuk-02.txt": 43043,
	"./allChapters/_22_havakuk-03.txt": 11958,
	"./allChapters/_23_tzefania-01.txt": 88740,
	"./allChapters/_23_tzefania-02.txt": 14531,
	"./allChapters/_23_tzefania-03.txt": 56150,
	"./allChapters/_24_haggai-01.txt": 32704,
	"./allChapters/_24_haggai-02.txt": 52911,
	"./allChapters/_25_zecharia-01.txt": 87317,
	"./allChapters/_25_zecharia-02.txt": 76746,
	"./allChapters/_25_zecharia-03.txt": 8503,
	"./allChapters/_25_zecharia-04.txt": 19172,
	"./allChapters/_25_zecharia-05.txt": 40929,
	"./allChapters/_25_zecharia-06.txt": 12822,
	"./allChapters/_25_zecharia-07.txt": 9731,
	"./allChapters/_25_zecharia-08.txt": 48000,
	"./allChapters/_25_zecharia-09.txt": 60333,
	"./allChapters/_25_zecharia-10.txt": 85523,
	"./allChapters/_25_zecharia-11.txt": 77702,
	"./allChapters/_25_zecharia-12.txt": 7665,
	"./allChapters/_25_zecharia-13.txt": 88052,
	"./allChapters/_25_zecharia-14.txt": 25492,
	"./allChapters/_26_malachi-01.txt": 82790,
	"./allChapters/_26_malachi-02.txt": 12753,
	"./allChapters/_26_malachi-03.txt": 93140,
	"./allChapters/_27_tehilim-001.txt": 47099,
	"./allChapters/_27_tehilim-002.txt": 88471,
	"./allChapters/_27_tehilim-003.txt": 83562,
	"./allChapters/_27_tehilim-004.txt": 44193,
	"./allChapters/_27_tehilim-005.txt": 42340,
	"./allChapters/_27_tehilim-006.txt": 47171,
	"./allChapters/_27_tehilim-007.txt": 32438,
	"./allChapters/_27_tehilim-008.txt": 56653,
	"./allChapters/_27_tehilim-009.txt": 78112,
	"./allChapters/_27_tehilim-010.txt": 51546,
	"./allChapters/_27_tehilim-011.txt": 64487,
	"./allChapters/_27_tehilim-012.txt": 70648,
	"./allChapters/_27_tehilim-013.txt": 33829,
	"./allChapters/_27_tehilim-014.txt": 40518,
	"./allChapters/_27_tehilim-015.txt": 64691,
	"./allChapters/_27_tehilim-016.txt": 92948,
	"./allChapters/_27_tehilim-017.txt": 34417,
	"./allChapters/_27_tehilim-018.txt": 83442,
	"./allChapters/_27_tehilim-019.txt": 60799,
	"./allChapters/_27_tehilim-020.txt": 30399,
	"./allChapters/_27_tehilim-021.txt": 22418,
	"./allChapters/_27_tehilim-022.txt": 61597,
	"./allChapters/_27_tehilim-023.txt": 42960,
	"./allChapters/_27_tehilim-024.txt": 84011,
	"./allChapters/_27_tehilim-025.txt": 99070,
	"./allChapters/_27_tehilim-026.txt": 62825,
	"./allChapters/_27_tehilim-027.txt": 90188,
	"./allChapters/_27_tehilim-028.txt": 3463,
	"./allChapters/_27_tehilim-029.txt": 78618,
	"./allChapters/_27_tehilim-030.txt": 80730,
	"./allChapters/_27_tehilim-031.txt": 68401,
	"./allChapters/_27_tehilim-032.txt": 27046,
	"./allChapters/_27_tehilim-033.txt": 58163,
	"./allChapters/_27_tehilim-034.txt": 68568,
	"./allChapters/_27_tehilim-035.txt": 84165,
	"./allChapters/_27_tehilim-036.txt": 1882,
	"./allChapters/_27_tehilim-037.txt": 6375,
	"./allChapters/_27_tehilim-038.txt": 44684,
	"./allChapters/_27_tehilim-039.txt": 74185,
	"./allChapters/_27_tehilim-040.txt": 13161,
	"./allChapters/_27_tehilim-041.txt": 83660,
	"./allChapters/_27_tehilim-042.txt": 16555,
	"./allChapters/_27_tehilim-043.txt": 49406,
	"./allChapters/_27_tehilim-044.txt": 77309,
	"./allChapters/_27_tehilim-045.txt": 42320,
	"./allChapters/_27_tehilim-046.txt": 9023,
	"./allChapters/_27_tehilim-047.txt": 80082,
	"./allChapters/_27_tehilim-048.txt": 84081,
	"./allChapters/_27_tehilim-049.txt": 64468,
	"./allChapters/_27_tehilim-050.txt": 32110,
	"./allChapters/_27_tehilim-051.txt": 40763,
	"./allChapters/_27_tehilim-052.txt": 12316,
	"./allChapters/_27_tehilim-053.txt": 44281,
	"./allChapters/_27_tehilim-054.txt": 55458,
	"./allChapters/_27_tehilim-055.txt": 90703,
	"./allChapters/_27_tehilim-056.txt": 24416,
	"./allChapters/_27_tehilim-057.txt": 36749,
	"./allChapters/_27_tehilim-058.txt": 5590,
	"./allChapters/_27_tehilim-059.txt": 86147,
	"./allChapters/_27_tehilim-060.txt": 55027,
	"./allChapters/_27_tehilim-061.txt": 30854,
	"./allChapters/_27_tehilim-062.txt": 24753,
	"./allChapters/_27_tehilim-063.txt": 83284,
	"./allChapters/_27_tehilim-064.txt": 54823,
	"./allChapters/_27_tehilim-065.txt": 41882,
	"./allChapters/_27_tehilim-066.txt": 24165,
	"./allChapters/_27_tehilim-067.txt": 60984,
	"./allChapters/_27_tehilim-068.txt": 58667,
	"./allChapters/_27_tehilim-069.txt": 50430,
	"./allChapters/_27_tehilim-070.txt": 67400,
	"./allChapters/_27_tehilim-071.txt": 5845,
	"./allChapters/_27_tehilim-072.txt": 23562,
	"./allChapters/_27_tehilim-073.txt": 21143,
	"./allChapters/_27_tehilim-074.txt": 88676,
	"./allChapters/_27_tehilim-075.txt": 48961,
	"./allChapters/_27_tehilim-076.txt": 72438,
	"./allChapters/_27_tehilim-077.txt": 30819,
	"./allChapters/_27_tehilim-078.txt": 18112,
	"./allChapters/_27_tehilim-079.txt": 37165,
	"./allChapters/_27_tehilim-080.txt": 67485,
	"./allChapters/_27_tehilim-081.txt": 6320,
	"./allChapters/_27_tehilim-082.txt": 70463,
	"./allChapters/_27_tehilim-083.txt": 93106,
	"./allChapters/_27_tehilim-084.txt": 26185,
	"./allChapters/_27_tehilim-085.txt": 3404,
	"./allChapters/_27_tehilim-086.txt": 77995,
	"./allChapters/_27_tehilim-087.txt": 69758,
	"./allChapters/_27_tehilim-088.txt": 43493,
	"./allChapters/_27_tehilim-089.txt": 80312,
	"./allChapters/_27_tehilim-090.txt": 10402,
	"./allChapters/_27_tehilim-091.txt": 46255,
	"./allChapters/_27_tehilim-092.txt": 37440,
	"./allChapters/_27_tehilim-093.txt": 56493,
	"./allChapters/_27_tehilim-094.txt": 70702,
	"./allChapters/_27_tehilim-095.txt": 30491,
	"./allChapters/_27_tehilim-096.txt": 36668,
	"./allChapters/_27_tehilim-097.txt": 8281,
	"./allChapters/_27_tehilim-098.txt": 42890,
	"./allChapters/_27_tehilim-099.txt": 40471,
	"./allChapters/_27_tehilim-100.txt": 45536,
	"./allChapters/_27_tehilim-101.txt": 24077,
	"./allChapters/_27_tehilim-102.txt": 26434,
	"./allChapters/_27_tehilim-103.txt": 54351,
	"./allChapters/_27_tehilim-104.txt": 36316,
	"./allChapters/_27_tehilim-105.txt": 7929,
	"./allChapters/_27_tehilim-106.txt": 95758,
	"./allChapters/_27_tehilim-107.txt": 38587,
	"./allChapters/_27_tehilim-108.txt": 36904,
	"./allChapters/_27_tehilim-109.txt": 4085,
	"./allChapters/_27_tehilim-110.txt": 56907,
	"./allChapters/_27_tehilim-111.txt": 20382,
	"./allChapters/_27_tehilim-112.txt": 41609,
	"./allChapters/_27_tehilim-113.txt": 89727,
	"./allChapters/_27_tehilim-114.txt": 30143,
	"./allChapters/_27_tehilim-115.txt": 43730,
	"./allChapters/_27_tehilim-116.txt": 48285,
	"./allChapters/_27_tehilim-117.txt": 40144,
	"./allChapters/_27_tehilim-118.txt": 25587,
	"./allChapters/_27_tehilim-119.txt": 94470,
	"./allChapters/_27_tehilim-120.txt": 78790,
	"./allChapters/_27_tehilim-121.txt": 86611,
	"./allChapters/_27_tehilim-122.txt": 89140,
	"./allChapters/_27_tehilim-123.txt": 8753,
	"./allChapters/_27_tehilim-124.txt": 53626,
	"./allChapters/_27_tehilim-125.txt": 4199,
	"./allChapters/_27_tehilim-126.txt": 8920,
	"./allChapters/_27_tehilim-127.txt": 12613,
	"./allChapters/_27_tehilim-128.txt": 74078,
	"./allChapters/_27_tehilim-129.txt": 41227,
	"./allChapters/_27_tehilim-130.txt": 73633,
	"./allChapters/_27_tehilim-131.txt": 13348,
	"./allChapters/_27_tehilim-132.txt": 55491,
	"./allChapters/_27_tehilim-133.txt": 97110,
	"./allChapters/_27_tehilim-134.txt": 30517,
	"./allChapters/_27_tehilim-135.txt": 92072,
	"./allChapters/_27_tehilim-136.txt": 45815,
	"./allChapters/_27_tehilim-137.txt": 48234,
	"./allChapters/_27_tehilim-138.txt": 13625,
	"./allChapters/_27_tehilim-139.txt": 42012,
	"./allChapters/_27_tehilim-140.txt": 14860,
	"./allChapters/_27_tehilim-141.txt": 87497,
	"./allChapters/_27_tehilim-142.txt": 23742,
	"./allChapters/_27_tehilim-143.txt": 8683,
	"./allChapters/_27_tehilim-144.txt": 67632,
	"./allChapters/_27_tehilim-145.txt": 86269,
	"./allChapters/_27_tehilim-146.txt": 47090,
	"./allChapters/_27_tehilim-147.txt": 55071,
	"./allChapters/_27_tehilim-148.txt": 87220,
	"./allChapters/_27_tehilim-149.txt": 81713,
	"./allChapters/_27_tehilim-150.txt": 9591,
	"./allChapters/_28_mishley-01.txt": 57444,
	"./allChapters/_28_mishley-02.txt": 83235,
	"./allChapters/_28_mishley-03.txt": 24854,
	"./allChapters/_28_mishley-04.txt": 74613,
	"./allChapters/_28_mishley-05.txt": 36168,
	"./allChapters/_28_mishley-06.txt": 89911,
	"./allChapters/_28_mishley-07.txt": 92330,
	"./allChapters/_28_mishley-08.txt": 41369,
	"./allChapters/_28_mishley-09.txt": 86108,
	"./allChapters/_28_mishley-10.txt": 6534,
	"./allChapters/_28_mishley-11.txt": 30707,
	"./allChapters/_28_mishley-12.txt": 33236,
	"./allChapters/_28_mishley-13.txt": 52849,
	"./allChapters/_28_mishley-14.txt": 97722,
	"./allChapters/_28_mishley-15.txt": 48295,
	"./allChapters/_28_mishley-16.txt": 36664,
	"./allChapters/_28_mishley-17.txt": 56709,
	"./allChapters/_28_mishley-18.txt": 1822,
	"./allChapters/_28_mishley-19.txt": 85323,
	"./allChapters/_28_mishley-20.txt": 1003,
	"./allChapters/_28_mishley-21.txt": 48126,
	"./allChapters/_28_mishley-22.txt": 85705,
	"./allChapters/_28_mishley-23.txt": 56204,
	"./allChapters/_28_mishley-24.txt": 57887,
	"./allChapters/_28_mishley-25.txt": 71474,
	"./allChapters/_28_mishley-26.txt": 76029,
	"./allChapters/_28_mishley-27.txt": 84240,
	"./allChapters/_28_mishley-28.txt": 69683,
	"./allChapters/_28_mishley-29.txt": 22214,
	"./allChapters/_28_mishley-30.txt": 89632,
	"./allChapters/_28_mishley-31.txt": 51821,
	"./allChapters/_29_iyov-01.txt": 43477,
	"./allChapters/_29_iyov-02.txt": 15114,
	"./allChapters/_29_iyov-03.txt": 46871,
	"./allChapters/_29_iyov-04.txt": 26308,
	"./allChapters/_29_iyov-05.txt": 51009,
	"./allChapters/_29_iyov-06.txt": 51190,
	"./allChapters/_29_iyov-07.txt": 82723,
	"./allChapters/_29_iyov-08.txt": 55744,
	"./allChapters/_29_iyov-09.txt": 98093,
	"./allChapters/_29_iyov-10.txt": 6931,
	"./allChapters/_29_iyov-11.txt": 68486,
	"./allChapters/_29_iyov-12.txt": 69329,
	"./allChapters/_29_iyov-13.txt": 74836,
	"./allChapters/_29_iyov-14.txt": 99399,
	"./allChapters/_29_iyov-15.txt": 90906,
	"./allChapters/_29_iyov-16.txt": 19269,
	"./allChapters/_29_iyov-17.txt": 29240,
	"./allChapters/_29_iyov-18.txt": 96299,
	"./allChapters/_29_iyov-19.txt": 11358,
	"./allChapters/_29_iyov-20.txt": 93038,
	"./allChapters/_29_iyov-21.txt": 35867,
	"./allChapters/_29_iyov-22.txt": 33596,
	"./allChapters/_29_iyov-23.txt": 5209,
	"./allChapters/_29_iyov-24.txt": 23714,
	"./allChapters/_29_iyov-25.txt": 35279,
	"./allChapters/_29_iyov-26.txt": 42816,
	"./allChapters/_29_iyov-27.txt": 5005,
	"./allChapters/_29_iyov-28.txt": 80790,
	"./allChapters/_29_iyov-29.txt": 11875,
	"./allChapters/_29_iyov-30.txt": 38889,
	"./allChapters/_29_iyov-31.txt": 9388,
	"./allChapters/_29_iyov-32.txt": 54187,
	"./allChapters/_29_iyov-33.txt": 1310,
	"./allChapters/_29_iyov-34.txt": 29213,
	"./allChapters/_29_iyov-35.txt": 37424,
	"./allChapters/_29_iyov-36.txt": 11071,
	"./allChapters/_29_iyov-37.txt": 24658,
	"./allChapters/_29_iyov-38.txt": 33105,
	"./allChapters/_29_iyov-39.txt": 90196,
	"./allChapters/_29_iyov-40.txt": 86420,
	"./allChapters/_29_iyov-41.txt": 6033,
	"./allChapters/_29_iyov-42.txt": 76070,
	"./allChapters/_2_shemot-01.txt": 12065,
	"./allChapters/_2_shemot-02.txt": 83958,
	"./allChapters/_2_shemot-03.txt": 15043,
	"./allChapters/_2_shemot-04.txt": 21000,
	"./allChapters/_2_shemot-05.txt": 4533,
	"./allChapters/_2_shemot-06.txt": 51434,
	"./allChapters/_2_shemot-07.txt": 56343,
	"./allChapters/_2_shemot-08.txt": 36764,
	"./allChapters/_2_shemot-09.txt": 8377,
	"./allChapters/_2_shemot-10.txt": 31535,
	"./allChapters/_2_shemot-11.txt": 72386,
	"./allChapters/_2_shemot-12.txt": 53677,
	"./allChapters/_2_shemot-13.txt": 11328,
	"./allChapters/_2_shemot-14.txt": 27675,
	"./allChapters/_2_shemot-15.txt": 32686,
	"./allChapters/_2_shemot-16.txt": 36089,
	"./allChapters/_2_shemot-17.txt": 17500,
	"./allChapters/_2_shemot-18.txt": 2455,
	"./allChapters/_2_shemot-19.txt": 70698,
	"./allChapters/_2_shemot-20.txt": 1098,
	"./allChapters/_2_shemot-21.txt": 98679,
	"./allChapters/_2_shemot-22.txt": 44936,
	"./allChapters/_2_shemot-23.txt": 83381,
	"./allChapters/_2_shemot-24.txt": 33622,
	"./allChapters/_2_shemot-25.txt": 92003,
	"./allChapters/_2_shemot-26.txt": 66212,
	"./allChapters/_2_shemot-27.txt": 10145,
	"./allChapters/_2_shemot-28.txt": 52258,
	"./allChapters/_2_shemot-29.txt": 4463,
	"./allChapters/_2_shemot-30.txt": 1701,
	"./allChapters/_2_shemot-31.txt": 38520,
	"./allChapters/_2_shemot-32.txt": 32359,
	"./allChapters/_2_shemot-33.txt": 19418,
	"./allChapters/_2_shemot-34.txt": 85937,
	"./allChapters/_2_shemot-35.txt": 60820,
	"./allChapters/_2_shemot-36.txt": 16211,
	"./allChapters/_2_shemot-37.txt": 8390,
	"./allChapters/_2_shemot-38.txt": 9341,
	"./allChapters/_2_shemot-39.txt": 48176,
	"./allChapters/_2_shemot-40.txt": 35768,
	"./allChapters/_30_shir_hashirim-01.txt": 91204,
	"./allChapters/_30_shir_hashirim-02.txt": 65411,
	"./allChapters/_30_shir_hashirim-03.txt": 68502,
	"./allChapters/_30_shir_hashirim-04.txt": 42997,
	"./allChapters/_30_shir_hashirim-05.txt": 45192,
	"./allChapters/_30_shir_hashirim-06.txt": 64183,
	"./allChapters/_30_shir_hashirim-07.txt": 32426,
	"./allChapters/_30_shir_hashirim-08.txt": 23545,
	"./allChapters/_31_ruth-01.txt": 37668,
	"./allChapters/_31_ruth-02.txt": 28227,
	"./allChapters/_31_ruth-03.txt": 31318,
	"./allChapters/_31_ruth-04.txt": 5813,
	"./allChapters/_32_eicha-01.txt": 27014,
	"./allChapters/_32_eicha-02.txt": 4561,
	"./allChapters/_32_eicha-03.txt": 79444,
	"./allChapters/_32_eicha-04.txt": 50983,
	"./allChapters/_32_eicha-05.txt": 38042,
	"./allChapters/_33_koheleth-01.txt": 54489,
	"./allChapters/_33_koheleth-02.txt": 67438,
	"./allChapters/_33_koheleth-03.txt": 46075,
	"./allChapters/_33_koheleth-04.txt": 29728,
	"./allChapters/_33_koheleth-05.txt": 72077,
	"./allChapters/_33_koheleth-06.txt": 90786,
	"./allChapters/_33_koheleth-07.txt": 49935,
	"./allChapters/_33_koheleth-08.txt": 292,
	"./allChapters/_33_koheleth-09.txt": 24993,
	"./allChapters/_33_koheleth-10.txt": 89735,
	"./allChapters/_33_koheleth-11.txt": 64890,
	"./allChapters/_33_koheleth-12.txt": 93253,
	"./allChapters/_34_ester-01.txt": 49567,
	"./allChapters/_34_ester-02.txt": 85424,
	"./allChapters/_34_ester-03.txt": 46589,
	"./allChapters/_34_ester-04.txt": 48862,
	"./allChapters/_34_ester-05.txt": 57099,
	"./allChapters/_34_ester-06.txt": 82508,
	"./allChapters/_34_ester-07.txt": 5289,
	"./allChapters/_34_ester-08.txt": 40314,
	"./allChapters/_34_ester-09.txt": 53255,
	"./allChapters/_34_ester-10.txt": 29069,
	"./allChapters/_35_daniel-01.txt": 20586,
	"./allChapters/_35_daniel-02.txt": 2869,
	"./allChapters/_35_daniel-03.txt": 64424,
	"./allChapters/_35_daniel-04.txt": 11491,
	"./allChapters/_35_daniel-05.txt": 69462,
	"./allChapters/_35_daniel-06.txt": 29633,
	"./allChapters/_35_daniel-07.txt": 85700,
	"./allChapters/_35_daniel-08.txt": 23951,
	"./allChapters/_35_daniel-09.txt": 71746,
	"./allChapters/_35_daniel-10.txt": 80684,
	"./allChapters/_35_daniel-11.txt": 10185,
	"./allChapters/_35_daniel-12.txt": 30078,
	"./allChapters/_36_ezra-01.txt": 94976,
	"./allChapters/_36_ezra-02.txt": 44911,
	"./allChapters/_36_ezra-03.txt": 26018,
	"./allChapters/_36_ezra-04.txt": 14841,
	"./allChapters/_36_ezra-05.txt": 66524,
	"./allChapters/_36_ezra-06.txt": 11323,
	"./allChapters/_36_ezra-07.txt": 2670,
	"./allChapters/_36_ezra-08.txt": 34293,
	"./allChapters/_36_ezra-09.txt": 20136,
	"./allChapters/_36_ezra-10.txt": 76626,
	"./allChapters/_37_nechemia-01.txt": 23393,
	"./allChapters/_37_nechemia-02.txt": 23574,
	"./allChapters/_37_nechemia-03.txt": 55107,
	"./allChapters/_37_nechemia-04.txt": 34888,
	"./allChapters/_37_nechemia-05.txt": 99509,
	"./allChapters/_37_nechemia-06.txt": 87498,
	"./allChapters/_37_nechemia-07.txt": 19255,
	"./allChapters/_37_nechemia-08.txt": 34300,
	"./allChapters/_37_nechemia-09.txt": 36537,
	"./allChapters/_37_nechemia-10.txt": 11439,
	"./allChapters/_37_nechemia-11.txt": 92546,
	"./allChapters/_37_nechemia-12.txt": 73837,
	"./allChapters/_37_nechemia-13.txt": 61504,
	"./allChapters/_38_divrei_hayamim_a-01.txt": 56404,
	"./allChapters/_38_divrei_hayamim_a-02.txt": 4851,
	"./allChapters/_38_divrei_hayamim_a-03.txt": 50054,
	"./allChapters/_38_divrei_hayamim_a-04.txt": 837,
	"./allChapters/_38_divrei_hayamim_a-05.txt": 10808,
	"./allChapters/_38_divrei_hayamim_a-06.txt": 97319,
	"./allChapters/_38_divrei_hayamim_a-07.txt": 72474,
	"./allChapters/_38_divrei_hayamim_a-08.txt": 56681,
	"./allChapters/_38_divrei_hayamim_a-09.txt": 84044,
	"./allChapters/_38_divrei_hayamim_a-10.txt": 49110,
	"./allChapters/_38_divrei_hayamim_a-11.txt": 80643,
	"./allChapters/_38_divrei_hayamim_a-12.txt": 7876,
	"./allChapters/_38_divrei_hayamim_a-13.txt": 32577,
	"./allChapters/_38_divrei_hayamim_a-14.txt": 96682,
	"./allChapters/_38_divrei_hayamim_a-15.txt": 28439,
	"./allChapters/_38_divrei_hayamim_a-16.txt": 44072,
	"./allChapters/_38_divrei_hayamim_a-17.txt": 25045,
	"./allChapters/_38_divrei_hayamim_a-18.txt": 75022,
	"./allChapters/_38_divrei_hayamim_a-19.txt": 53659,
	"./allChapters/_38_divrei_hayamim_a-20.txt": 57435,
	"./allChapters/_38_divrei_hayamim_a-21.txt": 97646,
	"./allChapters/_38_divrei_hayamim_a-22.txt": 35225,
	"./allChapters/_38_divrei_hayamim_a-23.txt": 63612,
	"./allChapters/_38_divrei_hayamim_a-24.txt": 73199,
	"./allChapters/_38_divrei_hayamim_a-25.txt": 20994,
	"./allChapters/_38_divrei_hayamim_a-26.txt": 83437,
	"./allChapters/_38_divrei_hayamim_a-27.txt": 64384,
	"./allChapters/_38_divrei_hayamim_a-28.txt": 77091,
	"./allChapters/_38_divrei_hayamim_a-29.txt": 18710,
	"./allChapters/_39_divrei_hayamim_b-01.txt": 39260,
	"./allChapters/_39_divrei_hayamim_b-02.txt": 33083,
	"./allChapters/_39_divrei_hayamim_b-03.txt": 73294,
	"./allChapters/_39_divrei_hayamim_b-04.txt": 59085,
	"./allChapters/_39_divrei_hayamim_b-05.txt": 40032,
	"./allChapters/_39_divrei_hayamim_b-06.txt": 48847,
	"./allChapters/_39_divrei_hayamim_b-07.txt": 96642,
	"./allChapters/_39_divrei_hayamim_b-08.txt": 54529,
	"./allChapters/_39_divrei_hayamim_b-09.txt": 10596,
	"./allChapters/_39_divrei_hayamim_b-10.txt": 54974,
	"./allChapters/_39_divrei_hayamim_b-11.txt": 38475,
	"./allChapters/_39_divrei_hayamim_b-12.txt": 5580,
	"./allChapters/_39_divrei_hayamim_b-13.txt": 35081,
	"./allChapters/_39_divrei_hayamim_b-14.txt": 2002,
	"./allChapters/_39_divrei_hayamim_b-15.txt": 14591,
	"./allChapters/_39_divrei_hayamim_b-16.txt": 64240,
	"./allChapters/_39_divrei_hayamim_b-17.txt": 82877,
	"./allChapters/_39_divrei_hayamim_b-18.txt": 76038,
	"./allChapters/_39_divrei_hayamim_b-19.txt": 83859,
	"./allChapters/_39_divrei_hayamim_b-20.txt": 59427,
	"./allChapters/_39_divrei_hayamim_b-21.txt": 28342,
	"./allChapters/_39_divrei_hayamim_b-22.txt": 56449,
	"./allChapters/_39_divrei_hayamim_b-23.txt": 38244,
	"./allChapters/_39_divrei_hayamim_b-24.txt": 727,
	"./allChapters/_39_divrei_hayamim_b-25.txt": 95818,
	"./allChapters/_39_divrei_hayamim_b-26.txt": 48917,
	"./allChapters/_39_divrei_hayamim_b-27.txt": 65384,
	"./allChapters/_39_divrei_hayamim_b-28.txt": 83419,
	"./allChapters/_39_divrei_hayamim_b-29.txt": 40590,
	"./allChapters/_39_divrei_hayamim_b-30.txt": 82904,
	"./allChapters/_39_divrei_hayamim_b-31.txt": 46085,
	"./allChapters/_39_divrei_hayamim_b-32.txt": 63802,
	"./allChapters/_39_divrei_hayamim_b-33.txt": 76743,
	"./allChapters/_39_divrei_hayamim_b-34.txt": 5204,
	"./allChapters/_39_divrei_hayamim_b-35.txt": 30321,
	"./allChapters/_39_divrei_hayamim_b-36.txt": 52774,
	"./allChapters/_3_vayikra-01.txt": 64919,
	"./allChapters/_3_vayikra-02.txt": 45928,
	"./allChapters/_3_vayikra-03.txt": 43733,
	"./allChapters/_3_vayikra-04.txt": 69238,
	"./allChapters/_3_vayikra-05.txt": 66147,
	"./allChapters/_3_vayikra-06.txt": 91940,
	"./allChapters/_3_vayikra-07.txt": 97345,
	"./allChapters/_3_vayikra-08.txt": 35458,
	"./allChapters/_3_vayikra-09.txt": 70703,
	"./allChapters/_3_vayikra-10.txt": 67941,
	"./allChapters/_3_vayikra-11.txt": 64248,
	"./allChapters/_3_vayikra-12.txt": 59527,
	"./allChapters/_3_vayikra-13.txt": 8954,
	"./allChapters/_3_vayikra-14.txt": 64081,
	"./allChapters/_3_vayikra-15.txt": 44468,
	"./allChapters/_3_vayikra-16.txt": 41939,
	"./allChapters/_3_vayikra-17.txt": 34118,
	"./allChapters/_3_vayikra-18.txt": 40957,
	"./allChapters/_3_vayikra-19.txt": 22320,
	"./allChapters/_3_vayikra-20.txt": 68676,
	"./allChapters/_3_vayikra-21.txt": 28961,
	"./allChapters/_3_vayikra-22.txt": 52438,
	"./allChapters/_3_vayikra-23.txt": 10819,
	"./allChapters/_3_vayikra-24.txt": 47400,
	"./allChapters/_3_vayikra-25.txt": 85845,
	"./allChapters/_3_vayikra-26.txt": 3562,
	"./allChapters/_3_vayikra-27.txt": 1143,
	"./allChapters/_4_bamidbar-01.txt": 66091,
	"./allChapters/_4_bamidbar-02.txt": 21292,
	"./allChapters/_4_bamidbar-03.txt": 50793,
	"./allChapters/_4_bamidbar-04.txt": 52914,
	"./allChapters/_4_bamidbar-05.txt": 39327,
	"./allChapters/_4_bamidbar-06.txt": 49328,
	"./allChapters/_4_bamidbar-07.txt": 57469,
	"./allChapters/_4_bamidbar-08.txt": 3654,
	"./allChapters/_4_bamidbar-09.txt": 34771,
	"./allChapters/_4_bamidbar-10.txt": 92409,
	"./allChapters/_4_bamidbar-11.txt": 90172,
	"./allChapters/_4_bamidbar-12.txt": 83995,
	"./allChapters/_4_bamidbar-13.txt": 5358,
	"./allChapters/_4_bamidbar-14.txt": 9997,
	"./allChapters/_4_bamidbar-15.txt": 67648,
	"./allChapters/_4_bamidbar-16.txt": 87855,
	"./allChapters/_4_bamidbar-17.txt": 28706,
	"./allChapters/_4_bamidbar-18.txt": 79265,
	"./allChapters/_4_bamidbar-19.txt": 38212,
	"./allChapters/_4_bamidbar-20.txt": 41144,
	"./allChapters/_4_bamidbar-21.txt": 31173,
	"./allChapters/_4_bamidbar-22.txt": 2810,
	"./allChapters/_4_bamidbar-23.txt": 27655,
	"./allChapters/_4_bamidbar-24.txt": 86740,
	"./allChapters/_4_bamidbar-25.txt": 81233,
	"./allChapters/_4_bamidbar-26.txt": 80390,
	"./allChapters/_4_bamidbar-27.txt": 35187,
	"./allChapters/_4_bamidbar-28.txt": 67152,
	"./allChapters/_4_bamidbar-29.txt": 85789,
	"./allChapters/_4_bamidbar-30.txt": 10339,
	"./allChapters/_4_bamidbar-31.txt": 29782,
	"./allChapters/_4_bamidbar-32.txt": 41537,
	"./allChapters/_4_bamidbar-33.txt": 36132,
	"./allChapters/_4_bamidbar-34.txt": 9111,
	"./allChapters/_4_bamidbar-35.txt": 77354,
	"./allChapters/_4_bamidbar-36.txt": 87925,
	"./allChapters/_5_devarim-01.txt": 46374,
	"./allChapters/_5_devarim-02.txt": 92689,
	"./allChapters/_5_devarim-03.txt": 73076,
	"./allChapters/_5_devarim-04.txt": 88135,
	"./allChapters/_5_devarim-05.txt": 37562,
	"./allChapters/_5_devarim-06.txt": 96549,
	"./allChapters/_5_devarim-07.txt": 76504,
	"./allChapters/_5_devarim-08.txt": 25163,
	"./allChapters/_5_devarim-09.txt": 41662,
	"./allChapters/_5_devarim-10.txt": 58184,
	"./allChapters/_5_devarim-11.txt": 72341,
	"./allChapters/_5_devarim-12.txt": 61770,
	"./allChapters/_5_devarim-13.txt": 93527,
	"./allChapters/_5_devarim-14.txt": 4196,
	"./allChapters/_5_devarim-15.txt": 25953,
	"./allChapters/_5_devarim-16.txt": 97846,
	"./allChapters/_5_devarim-17.txt": 94755,
	"./allChapters/_5_devarim-18.txt": 33024,
	"./allChapters/_5_devarim-19.txt": 45357,
	"./allChapters/_5_devarim-20.txt": 71433,
	"./allChapters/_5_devarim-21.txt": 82444,
	"./allChapters/_5_devarim-22.txt": 92619,
	"./allChapters/_5_devarim-23.txt": 91326,
	"./allChapters/_5_devarim-24.txt": 70205,
	"./allChapters/_5_devarim-25.txt": 35216,
	"./allChapters/_5_devarim-26.txt": 22655,
	"./allChapters/_5_devarim-27.txt": 14674,
	"./allChapters/_5_devarim-28.txt": 65649,
	"./allChapters/_5_devarim-29.txt": 71156,
	"./allChapters/_5_devarim-30.txt": 73422,
	"./allChapters/_5_devarim-31.txt": 68411,
	"./allChapters/_5_devarim-32.txt": 58236,
	"./allChapters/_5_devarim-33.txt": 76825,
	"./allChapters/_5_devarim-34.txt": 96770,
	"./allChapters/_6_yehoshua-01.txt": 49653,
	"./allChapters/_6_yehoshua-02.txt": 21290,
	"./allChapters/_6_yehoshua-03.txt": 53047,
	"./allChapters/_6_yehoshua-04.txt": 32484,
	"./allChapters/_6_yehoshua-05.txt": 57185,
	"./allChapters/_6_yehoshua-06.txt": 73718,
	"./allChapters/_6_yehoshua-07.txt": 5251,
	"./allChapters/_6_yehoshua-08.txt": 61920,
	"./allChapters/_6_yehoshua-09.txt": 4269,
	"./allChapters/_6_yehoshua-10.txt": 29459,
	"./allChapters/_6_yehoshua-11.txt": 74662,
	"./allChapters/_6_yehoshua-12.txt": 75505,
	"./allChapters/_6_yehoshua-13.txt": 81012,
	"./allChapters/_6_yehoshua-14.txt": 21927,
	"./allChapters/_6_yehoshua-15.txt": 97082,
	"./allChapters/_6_yehoshua-16.txt": 25445,
	"./allChapters/_6_yehoshua-17.txt": 35416,
	"./allChapters/_6_yehoshua-18.txt": 2475,
	"./allChapters/_6_yehoshua-19.txt": 17534,
	"./allChapters/_6_yehoshua-20.txt": 99214,
	"./allChapters/_6_yehoshua-21.txt": 42043,
	"./allChapters/_6_yehoshua-22.txt": 39772,
	"./allChapters/_6_yehoshua-23.txt": 11385,
	"./allChapters/_6_yehoshua-24.txt": 29890,
	"./allChapters/_7_shoftim-01.txt": 29386,
	"./allChapters/_7_shoftim-02.txt": 57749,
	"./allChapters/_7_shoftim-03.txt": 76776,
	"./allChapters/_7_shoftim-04.txt": 13347,
	"./allChapters/_7_shoftim-05.txt": 81814,
	"./allChapters/_7_shoftim-06.txt": 65281,
	"./allChapters/_7_shoftim-07.txt": 40580,
	"./allChapters/_7_shoftim-08.txt": 90223,
	"./allChapters/_7_shoftim-09.txt": 31074,
	"./allChapters/_7_shoftim-10.txt": 23660,
	"./allChapters/_7_shoftim-11.txt": 53161,
	"./allChapters/_7_shoftim-12.txt": 31934,
	"./allChapters/_7_shoftim-13.txt": 68459,
	"./allChapters/_7_shoftim-14.txt": 51696,
	"./allChapters/_7_shoftim-15.txt": 43485,
	"./allChapters/_7_shoftim-16.txt": 55282,
	"./allChapters/_7_shoftim-17.txt": 41695,
	"./allChapters/_7_shoftim-18.txt": 4468,
	"./allChapters/_7_shoftim-19.txt": 47377,
	"./allChapters/_7_shoftim-20.txt": 19277,
	"./allChapters/_7_shoftim-21.txt": 57088,
	"./allChapters/_8_shemuel_a-01.txt": 56358,
	"./allChapters/_8_shemuel_a-02.txt": 33905,
	"./allChapters/_8_shemuel_a-03.txt": 8788,
	"./allChapters/_8_shemuel_a-04.txt": 80327,
	"./allChapters/_8_shemuel_a-05.txt": 67386,
	"./allChapters/_8_shemuel_a-06.txt": 49669,
	"./allChapters/_8_shemuel_a-07.txt": 86488,
	"./allChapters/_8_shemuel_a-08.txt": 84171,
	"./allChapters/_8_shemuel_a-09.txt": 75934,
	"./allChapters/_8_shemuel_a-10.txt": 92904,
	"./allChapters/_8_shemuel_a-11.txt": 31349,
	"./allChapters/_8_shemuel_a-12.txt": 49066,
	"./allChapters/_8_shemuel_a-13.txt": 46647,
	"./allChapters/_8_shemuel_a-14.txt": 14180,
	"./allChapters/_8_shemuel_a-15.txt": 58113,
	"./allChapters/_8_shemuel_a-16.txt": 81590,
	"./allChapters/_8_shemuel_a-17.txt": 39971,
	"./allChapters/_8_shemuel_a-18.txt": 43616,
	"./allChapters/_8_shemuel_a-19.txt": 62669,
	"./allChapters/_8_shemuel_a-20.txt": 38665,
	"./allChapters/_8_shemuel_a-21.txt": 9164,
	"./allChapters/_8_shemuel_a-22.txt": 42059,
	"./allChapters/_8_shemuel_a-23.txt": 58558,
	"./allChapters/_8_shemuel_a-24.txt": 86461,
	"./allChapters/_8_shemuel_a-25.txt": 67824,
	"./allChapters/_8_shemuel_a-26.txt": 18175,
	"./allChapters/_8_shemuel_a-27.txt": 5586,
	"./allChapters/_8_shemuel_a-28.txt": 9585,
	"./allChapters/_8_shemuel_a-29.txt": 89972,
	"./allChapters/_8_shemuel_a-30.txt": 57614,
	"./allChapters/_8_shemuel_a-31.txt": 66267,
	"./allChapters/_9_shemuel_b-01.txt": 73344,
	"./allChapters/_9_shemuel_b-02.txt": 65807,
	"./allChapters/_9_shemuel_b-03.txt": 54242,
	"./allChapters/_9_shemuel_b-04.txt": 35737,
	"./allChapters/_9_shemuel_b-05.txt": 64124,
	"./allChapters/_9_shemuel_b-06.txt": 66395,
	"./allChapters/_9_shemuel_b-07.txt": 7214,
	"./allChapters/_9_shemuel_b-08.txt": 15541,
	"./allChapters/_9_shemuel_b-09.txt": 48360,
	"./allChapters/_9_shemuel_b-10.txt": 78674,
	"./allChapters/_9_shemuel_b-11.txt": 39679,
	"./allChapters/_9_shemuel_b-12.txt": 75536,
	"./allChapters/_9_shemuel_b-13.txt": 36701,
	"./allChapters/_9_shemuel_b-14.txt": 55326,
	"./allChapters/_9_shemuel_b-15.txt": 63563,
	"./allChapters/_9_shemuel_b-16.txt": 72620,
	"./allChapters/_9_shemuel_b-17.txt": 95401,
	"./allChapters/_9_shemuel_b-18.txt": 46778,
	"./allChapters/_9_shemuel_b-19.txt": 59719,
	"./allChapters/_9_shemuel_b-20.txt": 77399,
	"./allChapters/_9_shemuel_b-21.txt": 45642,
	"./allChapters/_9_shemuel_b-22.txt": 57653,
	"./allChapters/_9_shemuel_b-23.txt": 93032,
	"./allChapters/_9_shemuel_b-24.txt": 13251,
	"./animations/bible_search.json": 68682,
	"./draft.txt": 63860,
	"./fonts/Keter-Medium.ttf": 80871,
	"./iyov_tehilim_speakers.json": 22888,
	"./mikudLevels/READ_ME.txt": 20414,
	"./mikudLevels/adults/adults_international.txt": 96735,
	"./mikudLevels/adults/adults_national.txt": 79043,
	"./mikudLevels/adults/introduction_adults.txt": 74039,
	"./mikudLevels/full_mikud_list.txt": 41332,
	"./mikudLevels/mikud_menu.txt": 99809,
	"./mikudLevels/youth/introduction_youth.txt": 44877,
	"./mikudLevels/youth/youth_religious.txt": 30754,
	"./mikudLevels/youth/youth_state.txt": 41160,
	"./numbers.json": 55403,
	"./onqelos/_1_bereshit_onqelos.txt": 48504,
	"./onqelos/_2_shemot_onqelos.txt": 81065,
	"./onqelos/_3_vayikra_onqelos.txt": 13263,
	"./onqelos/_4_bamidbar_onqelos.txt": 40739,
	"./onqelos/_5_devarim_onqelos.txt": 48028,
	"./other/PyramidCrosswordGuide.txt": 81298,
	"./other/americanGuide_part1.txt": 78405,
	"./other/americanGuide_part2.txt": 97037,
	"./other/browseGuide.txt": 32208,
	"./other/completeVerseGuide.txt": 24890,
	"./other/create_sheet_for_open_questions_tutorial.txt": 54696,
	"./other/donateText.txt": 56558,
	"./other/draft.txt": 16123,
	"./other/help.txt": 45355,
	"./other/mikudGuide.txt": 22384,
	"./other/open_questionsGuide.txt": 23208,
	"./other/randomApproach.txt": 103,
	"./other/searchExamples.txt": 95411,
	"./other/searchGuide.txt": 1914,
	"./other/shareText.txt": 34306,
	"./other/shareTextHtml.txt": 28121,
	"./other/simchatTorahMaftir.txt": 55662,
	"./other/test.txt": 29274,
	"./other/test2.json": 90358,
	"./pairs/comments.txt": 28623,
	"./pairs/draft.json": 41044,
	"./pairs/draft2.json": 9062,
	"./pairs/pairs.json": 4410,
	"./pairs/test.txt": 13949,
	"./parashot/moadim.txt": 77597,
	"./parashot/parashot.json": 38016,
	"./peopleNames/names_10_melachim_a-01.txt": 64796,
	"./peopleNames/names_10_melachim_a-02.txt": 9595,
	"./peopleNames/names_10_melachim_a-03.txt": 942,
	"./peopleNames/names_10_melachim_a-05.txt": 93248,
	"./peopleNames/names_10_melachim_a-09.txt": 80772,
	"./peopleNames/names_10_melachim_a-10.txt": 67902,
	"./peopleNames/names_10_melachim_a-11.txt": 52843,
	"./peopleNames/names_10_melachim_a-14.txt": 91250,
	"./peopleNames/names_10_melachim_a-15.txt": 99231,
	"./peopleNames/names_10_melachim_a-16.txt": 11792,
	"./peopleNames/names_10_melachim_a-19.txt": 79827,
	"./peopleNames/names_10_melachim_a-20.txt": 83299,
	"./peopleNames/names_10_melachim_a-21.txt": 41270,
	"./peopleNames/names_10_melachim_a-22.txt": 1441,
	"./peopleNames/names_10_melachim_a.txt": 71852,
	"./peopleNames/names_11_melachim_b-05.txt": 13804,
	"./peopleNames/names_11_melachim_b-07.txt": 22078,
	"./peopleNames/names_11_melachim_b-08.txt": 53285,
	"./peopleNames/names_11_melachim_b-09.txt": 37688,
	"./peopleNames/names_11_melachim_b-11.txt": 56047,
	"./peopleNames/names_11_melachim_b-14.txt": 97454,
	"./peopleNames/names_11_melachim_b-15.txt": 40283,
	"./peopleNames/names_11_melachim_b-16.txt": 38012,
	"./peopleNames/names_11_melachim_b-17.txt": 9625,
	"./peopleNames/names_11_melachim_b-18.txt": 52682,
	"./peopleNames/names_11_melachim_b-19.txt": 57591,
	"./peopleNames/names_11_melachim_b-20.txt": 20167,
	"./peopleNames/names_11_melachim_b-21.txt": 11674,
	"./peopleNames/names_11_melachim_b-23.txt": 33656,
	"./peopleNames/names_11_melachim_b-24.txt": 27699,
	"./peopleNames/names_11_melachim_b-25.txt": 72902,
	"./peopleNames/names_11_melachim_b.txt": 41552,
	"./peopleNames/names_12_yeshaaya-07.txt": 98241,
	"./peopleNames/names_12_yeshaaya-08.txt": 36354,
	"./peopleNames/names_12_yeshaaya-13.txt": 9850,
	"./peopleNames/names_12_yeshaaya-14.txt": 64977,
	"./peopleNames/names_12_yeshaaya-15.txt": 45364,
	"./peopleNames/names_12_yeshaaya-16.txt": 42835,
	"./peopleNames/names_12_yeshaaya-17.txt": 18662,
	"./peopleNames/names_12_yeshaaya-19.txt": 23216,
	"./peopleNames/names_12_yeshaaya-22.txt": 36982,
	"./peopleNames/names_12_yeshaaya-23.txt": 95363,
	"./peopleNames/names_12_yeshaaya-36.txt": 64153,
	"./peopleNames/names_12_yeshaaya-37.txt": 92540,
	"./peopleNames/names_12_yeshaaya-38.txt": 12119,
	"./peopleNames/names_12_yeshaaya-39.txt": 7210,
	"./peopleNames/names_12_yeshaaya.txt": 55705,
	"./peopleNames/names_13_yirmeyah-20.txt": 93444,
	"./peopleNames/names_13_yirmeyah-26.txt": 98602,
	"./peopleNames/names_13_yirmeyah-28.txt": 45404,
	"./peopleNames/names_13_yirmeyah-29.txt": 47641,
	"./peopleNames/names_13_yirmeyah-32.txt": 84941,
	"./peopleNames/names_13_yirmeyah-35.txt": 80302,
	"./peopleNames/names_13_yirmeyah-36.txt": 92473,
	"./peopleNames/names_13_yirmeyah-37.txt": 44156,
	"./peopleNames/names_13_yirmeyah-38.txt": 16759,
	"./peopleNames/names_13_yirmeyah-40.txt": 81246,
	"./peopleNames/names_13_yirmeyah-41.txt": 64747,
	"./peopleNames/names_13_yirmeyah-43.txt": 45001,
	"./peopleNames/names_13_yirmeyah-45.txt": 40863,
	"./peopleNames/names_13_yirmeyah-46.txt": 90512,
	"./peopleNames/names_13_yirmeyah-47.txt": 9149,
	"./peopleNames/names_13_yirmeyah-48.txt": 85958,
	"./peopleNames/names_13_yirmeyah-49.txt": 10131,
	"./peopleNames/names_13_yirmeyah-50.txt": 20793,
	"./peopleNames/names_13_yirmeyah-51.txt": 49180,
	"./peopleNames/names_13_yirmeyah-52.txt": 59355,
	"./peopleNames/names_13_yirmeyah.txt": 30201,
	"./peopleNames/names_14_yechezkel-01.txt": 31922,
	"./peopleNames/names_14_yechezkel-24.txt": 53697,
	"./peopleNames/names_14_yechezkel-25.txt": 51844,
	"./peopleNames/names_14_yechezkel-26.txt": 56675,
	"./peopleNames/names_14_yechezkel-27.txt": 25590,
	"./peopleNames/names_14_yechezkel-28.txt": 49805,
	"./peopleNames/names_14_yechezkel-29.txt": 87616,
	"./peopleNames/names_14_yechezkel-30.txt": 61050,
	"./peopleNames/names_14_yechezkel-31.txt": 73991,
	"./peopleNames/names_14_yechezkel-32.txt": 80152,
	"./peopleNames/names_14_yechezkel-35.txt": 74195,
	"./peopleNames/names_14_yechezkel-38.txt": 92946,
	"./peopleNames/names_14_yechezkel-39.txt": 70303,
	"./peopleNames/names_14_yechezkel.txt": 70038,
	"./peopleNames/names_15_hoshea-01.txt": 4101,
	"./peopleNames/names_15_hoshea.txt": 77267,
	"./peopleNames/names_16_yoel.txt": 34309,
	"./peopleNames/names_17_amos-07.txt": 9481,
	"./peopleNames/names_17_amos.txt": 65249,
	"./peopleNames/names_18_ovadia.txt": 7394,
	"./peopleNames/names_19_yona.txt": 30408,
	"./peopleNames/names_1_bereshit-01.txt": 89540,
	"./peopleNames/names_1_bereshit-02.txt": 80099,
	"./peopleNames/names_1_bereshit-03.txt": 83190,
	"./peopleNames/names_1_bereshit-04.txt": 41333,
	"./peopleNames/names_1_bereshit-05.txt": 43528,
	"./peopleNames/names_1_bereshit-06.txt": 78871,
	"./peopleNames/names_1_bereshit-11.txt": 88595,
	"./peopleNames/names_1_bereshit-14.txt": 72570,
	"./peopleNames/names_1_bereshit-15.txt": 81063,
	"./peopleNames/names_1_bereshit-21.txt": 96798,
	"./peopleNames/names_1_bereshit-23.txt": 14092,
	"./peopleNames/names_1_bereshit-26.txt": 78173,
	"./peopleNames/names_1_bereshit-29.txt": 77222,
	"./peopleNames/names_1_bereshit-30.txt": 64480,
	"./peopleNames/names_1_bereshit-32.txt": 21090,
	"./peopleNames/names_1_bereshit-34.txt": 47356,
	"./peopleNames/names_1_bereshit-35.txt": 18969,
	"./peopleNames/names_1_bereshit-36.txt": 97742,
	"./peopleNames/names_1_bereshit-37.txt": 57531,
	"./peopleNames/names_1_bereshit-38.txt": 13768,
	"./peopleNames/names_1_bereshit-43.txt": 5378,
	"./peopleNames/names_1_bereshit-45.txt": 15260,
	"./peopleNames/names_1_bereshit-46.txt": 17531,
	"./peopleNames/names_1_bereshit-47.txt": 58350,
	"./peopleNames/names_1_bereshit-48.txt": 66677,
	"./peopleNames/names_1_bereshit-49.txt": 99496,
	"./peopleNames/names_1_bereshit-50.txt": 29810,
	"./peopleNames/names_1_bereshit.txt": 19988,
	"./peopleNames/names_20_micha-01.txt": 75819,
	"./peopleNames/names_20_micha.txt": 63661,
	"./peopleNames/names_21_nachum.txt": 1468,
	"./peopleNames/names_22_havakuk.txt": 45450,
	"./peopleNames/names_23_tzefania-01.txt": 87962,
	"./peopleNames/names_23_tzefania.txt": 68382,
	"./peopleNames/names_24_haggai.txt": 17522,
	"./peopleNames/names_25_zecharia-01.txt": 78327,
	"./peopleNames/names_25_zecharia-03.txt": 26517,
	"./peopleNames/names_25_zecharia-04.txt": 22294,
	"./peopleNames/names_25_zecharia-06.txt": 32196,
	"./peopleNames/names_25_zecharia-07.txt": 34049,
	"./peopleNames/names_25_zecharia.txt": 95993,
	"./peopleNames/names_26_malachi.txt": 77728,
	"./peopleNames/names_27_tehilim-072.txt": 16468,
	"./peopleNames/names_27_tehilim-127.txt": 74831,
	"./peopleNames/names_27_tehilim.txt": 32352,
	"./peopleNames/names_28_mishley-25.txt": 96100,
	"./peopleNames/names_28_mishley-30.txt": 21658,
	"./peopleNames/names_28_mishley-31.txt": 34599,
	"./peopleNames/names_28_mishley.txt": 85654,
	"./peopleNames/names_29_iyov-01.txt": 31163,
	"./peopleNames/names_29_iyov-02.txt": 28892,
	"./peopleNames/names_29_iyov-32.txt": 64625,
	"./peopleNames/names_29_iyov-42.txt": 34200,
	"./peopleNames/names_29_iyov.txt": 44701,
	"./peopleNames/names_2_shemot-01.txt": 37795,
	"./peopleNames/names_2_shemot-02.txt": 65028,
	"./peopleNames/names_2_shemot-04.txt": 53834,
	"./peopleNames/names_2_shemot-06.txt": 1224,
	"./peopleNames/names_2_shemot-13.txt": 7206,
	"./peopleNames/names_2_shemot-17.txt": 29626,
	"./peopleNames/names_2_shemot-18.txt": 13833,
	"./peopleNames/names_2_shemot-33.txt": 20764,
	"./peopleNames/names_2_shemot-35.txt": 78146,
	"./peopleNames/names_2_shemot-37.txt": 21536,
	"./peopleNames/names_2_shemot-38.txt": 34243,
	"./peopleNames/names_2_shemot.txt": 33253,
	"./peopleNames/names_30_shir_hashirim.txt": 11686,
	"./peopleNames/names_31_ruth.txt": 63738,
	"./peopleNames/names_32_eicha.txt": 49888,
	"./peopleNames/names_33_koheleth.txt": 34701,
	"./peopleNames/names_34_ester-01.txt": 34225,
	"./peopleNames/names_34_ester-02.txt": 87910,
	"./peopleNames/names_34_ester-04.txt": 18040,
	"./peopleNames/names_34_ester-05.txt": 38085,
	"./peopleNames/names_34_ester-06.txt": 79098,
	"./peopleNames/names_34_ester-09.txt": 46953,
	"./peopleNames/names_34_ester.txt": 98207,
	"./peopleNames/names_35_daniel-01.txt": 63492,
	"./peopleNames/names_35_daniel-02.txt": 89283,
	"./peopleNames/names_35_daniel-04.txt": 80661,
	"./peopleNames/names_35_daniel-05.txt": 42216,
	"./peopleNames/names_35_daniel-08.txt": 47417,
	"./peopleNames/names_35_daniel-09.txt": 75804,
	"./peopleNames/names_35_daniel-10.txt": 12582,
	"./peopleNames/names_35_daniel-12.txt": 39284,
	"./peopleNames/names_35_daniel.txt": 32692,
	"./peopleNames/names_36_ezra-01.txt": 59978,
	"./peopleNames/names_36_ezra-04.txt": 50883,
	"./peopleNames/names_36_ezra-05.txt": 8854,
	"./peopleNames/names_36_ezra-06.txt": 69025,
	"./peopleNames/names_36_ezra-07.txt": 25092,
	"./peopleNames/names_36_ezra-08.txt": 63343,
	"./peopleNames/names_36_ezra-10.txt": 20076,
	"./peopleNames/names_36_ezra.txt": 67374,
	"./peopleNames/names_37_nechemia-01.txt": 79907,
	"./peopleNames/names_37_nechemia-02.txt": 89348,
	"./peopleNames/names_37_nechemia-03.txt": 11105,
	"./peopleNames/names_37_nechemia-06.txt": 43336,
	"./peopleNames/names_37_nechemia-07.txt": 57493,
	"./peopleNames/names_37_nechemia-08.txt": 25870,
	"./peopleNames/names_37_nechemia-10.txt": 77841,
	"./peopleNames/names_37_nechemia-12.txt": 55699,
	"./peopleNames/names_37_nechemia-13.txt": 47878,
	"./peopleNames/names_37_nechemia.txt": 84453,
	"./peopleNames/names_38_divrei_hayamim_a-04.txt": 59843,
	"./peopleNames/names_38_divrei_hayamim_a-10.txt": 47532,
	"./peopleNames/names_38_divrei_hayamim_a-11.txt": 36521,
	"./peopleNames/names_38_divrei_hayamim_a-12.txt": 56414,
	"./peopleNames/names_38_divrei_hayamim_a-13.txt": 57707,
	"./peopleNames/names_38_divrei_hayamim_a-14.txt": 16656,
	"./peopleNames/names_38_divrei_hayamim_a-15.txt": 35293,
	"./peopleNames/names_38_divrei_hayamim_a-17.txt": 4095,
	"./peopleNames/names_38_divrei_hayamim_a-18.txt": 36244,
	"./peopleNames/names_38_divrei_hayamim_a-19.txt": 30737,
	"./peopleNames/names_38_divrei_hayamim_a-20.txt": 59501,
	"./peopleNames/names_38_divrei_hayamim_a-21.txt": 17152,
	"./peopleNames/names_38_divrei_hayamim_a.txt": 6606,
	"./peopleNames/names_39_divrei_hayamim_b-09.txt": 36390,
	"./peopleNames/names_39_divrei_hayamim_b-10.txt": 6688,
	"./peopleNames/names_39_divrei_hayamim_b-11.txt": 19021,
	"./peopleNames/names_39_divrei_hayamim_b-12.txt": 37730,
	"./peopleNames/names_39_divrei_hayamim_b-14.txt": 78236,
	"./peopleNames/names_39_divrei_hayamim_b-15.txt": 26553,
	"./peopleNames/names_39_divrei_hayamim_b-16.txt": 14382,
	"./peopleNames/names_39_divrei_hayamim_b-18.txt": 48200,
	"./peopleNames/names_39_divrei_hayamim_b-19.txt": 46005,
	"./peopleNames/names_39_divrei_hayamim_b-20.txt": 68577,
	"./peopleNames/names_39_divrei_hayamim_b-21.txt": 43876,
	"./peopleNames/names_39_divrei_hayamim_b-22.txt": 16643,
	"./peopleNames/names_39_divrei_hayamim_b-23.txt": 85110,
	"./peopleNames/names_39_divrei_hayamim_b-24.txt": 61045,
	"./peopleNames/names_39_divrei_hayamim_b-25.txt": 80072,
	"./peopleNames/names_39_divrei_hayamim_b-26.txt": 64439,
	"./peopleNames/names_39_divrei_hayamim_b-27.txt": 32682,
	"./peopleNames/names_39_divrei_hayamim_b-28.txt": 98073,
	"./peopleNames/names_39_divrei_hayamim_b-29.txt": 95836,
	"./peopleNames/names_39_divrei_hayamim_b-30.txt": 9318,
	"./peopleNames/names_39_divrei_hayamim_b-31.txt": 40435,
	"./peopleNames/names_39_divrei_hayamim_b-32.txt": 7764,
	"./peopleNames/names_39_divrei_hayamim_b-33.txt": 50673,
	"./peopleNames/names_39_divrei_hayamim_b-34.txt": 84154,
	"./peopleNames/names_39_divrei_hayamim_b-35.txt": 88647,
	"./peopleNames/names_39_divrei_hayamim_b-36.txt": 50840,
	"./peopleNames/names_39_divrei_hayamim_b.txt": 26498,
	"./peopleNames/names_3_vayikra-24.txt": 82318,
	"./peopleNames/names_3_vayikra.txt": 16007,
	"./peopleNames/names_4_bamidbar-10.txt": 50835,
	"./peopleNames/names_4_bamidbar-11.txt": 43014,
	"./peopleNames/names_4_bamidbar-13.txt": 95444,
	"./peopleNames/names_4_bamidbar-14.txt": 50631,
	"./peopleNames/names_4_bamidbar-16.txt": 19973,
	"./peopleNames/names_4_bamidbar-20.txt": 27918,
	"./peopleNames/names_4_bamidbar-21.txt": 52923,
	"./peopleNames/names_4_bamidbar-22.txt": 8124,
	"./peopleNames/names_4_bamidbar-23.txt": 56441,
	"./peopleNames/names_4_bamidbar-25.txt": 86511,
	"./peopleNames/names_4_bamidbar-27.txt": 48909,
	"./peopleNames/names_4_bamidbar.txt": 52035,
	"./peopleNames/names_5_devarim-01.txt": 44256,
	"./peopleNames/names_5_devarim-03.txt": 17218,
	"./peopleNames/names_5_devarim-33.txt": 1163,
	"./peopleNames/names_5_devarim.txt": 92256,
	"./peopleNames/names_6_yehoshua-02.txt": 11024,
	"./peopleNames/names_6_yehoshua-06.txt": 52364,
	"./peopleNames/names_6_yehoshua-07.txt": 65513,
	"./peopleNames/names_6_yehoshua-08.txt": 97658,
	"./peopleNames/names_6_yehoshua-10.txt": 5869,
	"./peopleNames/names_6_yehoshua-11.txt": 86816,
	"./peopleNames/names_6_yehoshua-14.txt": 41305,
	"./peopleNames/names_6_yehoshua-15.txt": 86044,
	"./peopleNames/names_6_yehoshua-16.txt": 79867,
	"./peopleNames/names_6_yehoshua-17.txt": 20078,
	"./peopleNames/names_6_yehoshua-18.txt": 74549,
	"./peopleNames/names_6_yehoshua-19.txt": 36104,
	"./peopleNames/names_6_yehoshua-22.txt": 19134,
	"./peopleNames/names_6_yehoshua.txt": 77345,
	"./peopleNames/names_7_shoftim-01.txt": 13444,
	"./peopleNames/names_7_shoftim-02.txt": 86211,
	"./peopleNames/names_7_shoftim-03.txt": 54678,
	"./peopleNames/names_7_shoftim-04.txt": 30613,
	"./peopleNames/names_7_shoftim-05.txt": 49640,
	"./peopleNames/names_7_shoftim-07.txt": 2250,
	"./peopleNames/names_7_shoftim-08.txt": 67641,
	"./peopleNames/names_7_shoftim-09.txt": 65404,
	"./peopleNames/names_7_shoftim-10.txt": 78886,
	"./peopleNames/names_7_shoftim-11.txt": 10003,
	"./peopleNames/names_7_shoftim-12.txt": 93684,
	"./peopleNames/names_7_shoftim-13.txt": 20241,
	"./peopleNames/names_7_shoftim-16.txt": 20408,
	"./peopleNames/names_7_shoftim-17.txt": 36005,
	"./peopleNames/names_7_shoftim-18.txt": 4798,
	"./peopleNames/names_7_shoftim-20.txt": 68395,
	"./peopleNames/names_7_shoftim-21.txt": 1246,
	"./peopleNames/names_7_shoftim.txt": 87700,
	"./peopleNames/names_8_shemuel_a-01.txt": 67808,
	"./peopleNames/names_8_shemuel_a-02.txt": 60271,
	"./peopleNames/names_8_shemuel_a-03.txt": 48706,
	"./peopleNames/names_8_shemuel_a-04.txt": 52582,
	"./peopleNames/names_8_shemuel_a-09.txt": 59176,
	"./peopleNames/names_8_shemuel_a-10.txt": 73138,
	"./peopleNames/names_8_shemuel_a-17.txt": 6217,
	"./peopleNames/names_8_shemuel_a-18.txt": 41242,
	"./peopleNames/names_8_shemuel_a-19.txt": 54183,
	"./peopleNames/names_8_shemuel_a-22.txt": 68469,
	"./peopleNames/names_8_shemuel_a-25.txt": 76182,
	"./peopleNames/names_8_shemuel_a-26.txt": 76001,
	"./peopleNames/names_8_shemuel_a.txt": 43488,
	"./peopleNames/names_9_shemuel_b-02.txt": 14721,
	"./peopleNames/names_9_shemuel_b-03.txt": 92964,
	"./peopleNames/names_9_shemuel_b-04.txt": 65943,
	"./peopleNames/names_9_shemuel_b-05.txt": 50538,
	"./peopleNames/names_9_shemuel_b-06.txt": 44757,
	"./peopleNames/names_9_shemuel_b-07.txt": 46952,
	"./peopleNames/names_9_shemuel_b-08.txt": 38139,
	"./peopleNames/names_9_shemuel_b-09.txt": 29486,
	"./peopleNames/names_9_shemuel_b-10.txt": 97976,
	"./peopleNames/names_9_shemuel_b-11.txt": 88005,
	"./peopleNames/names_9_shemuel_b-12.txt": 75994,
	"./peopleNames/names_9_shemuel_b-13.txt": 84487,
	"./peopleNames/names_9_shemuel_b-15.txt": 54417,
	"./peopleNames/names_9_shemuel_b-16.txt": 37222,
	"./peopleNames/names_9_shemuel_b-17.txt": 92019,
	"./peopleNames/names_9_shemuel_b-18.txt": 23984,
	"./peopleNames/names_9_shemuel_b-19.txt": 42621,
	"./peopleNames/names_9_shemuel_b-20.txt": 49241,
	"./peopleNames/names_9_shemuel_b-21.txt": 47004,
	"./peopleNames/names_9_shemuel_b-23.txt": 62190,
	"./peopleNames/names_9_shemuel_b-24.txt": 66829,
	"./peopleNames/names_9_shemuel_b.txt": 75066,
	"./pyramid/pyramid_questions.json": 69480,
	"./search/popular_searches_seed.json": 80854,
	"./sedarim.json": 67296,
	"./verses_per_chapter.csv": 77015,
	"./webview/table.html": 44136
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87436;